import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable, {
  pickConfigs,
} from "app/components/AppComponents/ConfigurableTable";
import paymentColumns from "./paymentColumns";

type Props = {
  name: string;
  reference: string;
  createdAtFrom: string;
  createdAtTo: string;
  history: any;
};

const query = gql`
  query AllPayments(
    $offset: Int
    $limit: Int
    $createdAtFrom: String
    $createdAtTo: String
    $reference: String
  ) {
    payments(
      offset: $offset
      limit: $limit
      created_at_from: $createdAtFrom
      created_at_to: $createdAtTo
      reference: $reference
    ) {
      payment_token
      reference
      created_at
      payable_amount
      merchant_amount
      user_fee_amount
      status
      payment_strategy
      snapmin_url
      secure3d_requested
      merchant {
        name
        id
        snapmin_url
      }
      device {
        phone_number
        snapmin_url
        external_reference
        user {
          email
          external_reference
          snapmin_url
        }
      }
    }
  }
`;

const withData = graphql<any, Props & PaginationProps>(query, {
  options: ({
    reference,
    createdAtFrom,
    createdAtTo,
    pagination: { offset, limit },
  }) => ({
    fetchPolicy: "network-only",
    variables: {
      reference,
      createdAtFrom,
      createdAtTo,
      offset,
      limit,
    },
  }),
});

export default withPagination(
  withData((props) => (
    <BOGraphQLLoader data={props.data}>
      <ConfigurableTable
        columnConfigs={pickConfigs(paymentColumns, [
          "Date",
          "Payment token",
          "Reference",
          "Snapmin",
          "User",
          "Merchant",
          "Payment strategy",
          "Device",
          "Payable amount",
          "Amount (Merchant)",
          "Service fee",
          "Secure 3D",
        ])}
        defaultColumns={[
          "Date",
          "User",
          "Merchant",
          "Payment strategy",
          "Device",
          "Payable amount",
          "Amount (Merchant)",
          "Service fee",
          "Secure 3D",
        ]}
        rows={props.data.payments || []}
        rowToLink={(row) => `/snapscan/ops/payments/${row.reference}/summary`}
        pagination={props.pagination}
        name={props.name}
        history={props.history}
      />
    </BOGraphQLLoader>
  ))
);
